import { Combobox } from './Combobox';

interface InlineSelectOption {
  value: string;
  label: string;
}

interface InlineSelectProps {
  /** Was hier ausgewaehlt wird -- fuer vorlesende Programme. */
  ariaLabel: string;
  value: string;
  options: readonly InlineSelectOption[];
  /** Fehlt das Recht zur Aenderung, steht der Wert nur da. */
  disabled?: boolean;
  /** Waehrend die Aenderung unterwegs ist. */
  busy?: boolean;
  onChange: (value: string) => void;
}

/**
 * Auswahl an Ort und Stelle -- F1-42.
 *
 * Status, Prioritaet und Bearbeiter aendert man am Ticket dutzendfach am Tag.
 * Der Weg dorthin waren bisher vier Handgriffe: Reiter "Felder" oeffnen, Feld
 * suchen, auswaehlen, speichern. Hier ist es einer.
 *
 * **Es sieht aus wie Text und ist ein Auswahlfeld mit Eingabe.** Solange
 * niemand darauf zeigt, steht nur der Wert da; ein Klick oeffnet die Liste,
 * Tippen grenzt sie ein -- wie bei jedem anderen Auswahlfeld seit F1-49. Es
 * ist mit der Tastatur erreichbar und traegt seine Beschriftung mit.
 *
 * **Gespeichert wird beim Wechsel, nicht auf Knopfdruck.** Ein Speichernknopf
 * neben einer einzelnen Auswahl waere ein zweiter Handgriff fuer nichts. Dass
 * die Aenderung unterwegs ist, zeigt ``busy``; dass sie angekommen ist, die
 * Anzeige selbst -- sie kommt aus der Antwort des Servers zurueck.
 *
 * Fehlschlaege behandelt die Seite darum herum: Diese Komponente meldet nur,
 * was gewaehlt wurde.
 */
export function InlineSelect({
  ariaLabel,
  value,
  options,
  disabled = false,
  busy = false,
  onChange,
}: InlineSelectProps) {
  const entries = options.map((option) => ({ id: option.value, label: option.label }));
  const chosen = entries.find((entry) => entry.id === value) ?? null;

  return (
    <span className={busy ? 'inline-edit inline-edit--busy' : 'inline-edit'}>
      <Combobox
        ariaLabel={ariaLabel}
        className="combobox--inline"
        inputClassName="inline-edit__control"
        value={chosen}
        placeholder={entries.find((entry) => entry.id === '')?.label}
        options={entries}
        clearable={false}
        disabled={disabled || busy}
        onChange={(option) => {
          const next = option?.id ?? '';
          if (next !== value) onChange(next);
        }}
      />
    </span>
  );
}
